import { render, staticRenderFns } from "./RedirectErpAuth.vue?vue&type=template&id=9e2f7d34&"
import script from "./RedirectErpAuth.vue?vue&type=script&lang=js&"
export * from "./RedirectErpAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports